import { observer } from 'mobx-react-lite'
import { CSSProperties, FC, MutableRefObject, useEffect, useRef } from 'react'
import { useVideoFromFrames } from '../process/hooks'
import { ProgressContainer } from '@ui/ProgressContainer'
import { VideoInfoStore } from '@entities/VideoCaptureStore'
import { ResultFrame } from '@entities/Frame'
import { Circle } from '@features/exercise/AIVideo/ui/circle.ui'

interface Props {
	frames: { frame: string; frameData: ResultFrame }[]
	style?: CSSProperties
}

export const VideoFromFrames: FC<Props> = observer(({ frames, style }) => {
	const videoCaptureStore = VideoInfoStore.instance
	const video: File | null = videoCaptureStore.video

	const canvasRef: MutableRefObject<HTMLCanvasElement | null> = useRef<HTMLCanvasElement | null>(
		null
	)
	const videoRef: MutableRefObject<HTMLVideoElement | null> = useRef<HTMLVideoElement | null>(
		null
	)

	const width: number = window.innerWidth - 32

	const { currentFrame, circlePositions } = useVideoFromFrames(
		canvasRef,
		videoRef, // Передаем ref на видео
		frames,
		videoCaptureStore.framesDelayTime,
		() => {
			videoCaptureStore.replayCounter++
		}
	)

	return (
		<div style={{ position: 'relative', ...style }}>
			<ProgressContainer
				currentTime={currentFrame}
				maxTime={videoCaptureStore.framesToShow.length}>
				<video
					ref={videoRef}
					src={video ? URL.createObjectURL(video) : ''}
					style={{
						width: 'calc(100vw - 32px)',
						height: 'auto',
						border: '1px solid black',
						borderRadius: 35,
						transition: '300ms',
					}}
					controls={false}
				/>
				<canvas
					ref={canvasRef}
					height={314}
					width={width}
					style={{
						position: 'absolute',
						top: 0,
						left: 0,
						width: 'calc(100vw - 32px)',
						height: 'auto',
						pointerEvents: 'none',
					}}
				/>
				{circlePositions.map((circle, index) => {
					return (
						<Circle key={index} left={circle.x} top={circle.y} type={circle.viewType} />
					)
				})}
			</ProgressContainer>
		</div>
	)
})
